import React, { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import SearchHeader from "../components/SearchHeader";
import ViewComplaints from "../components/complaints/ViewComplaints";
import { useParams } from "react-router-dom";
import { useLoader } from "../context/LoaderContext";
import { IComplaint } from "../exports/interfaces";
import { useUser } from "../context/UserContext";
import { dynamicFailed } from "../hooks/useToast";
import { fetchComplaints } from "../api/ComplaintApi";

const ViewComplaintsPage = () => {
  const { id } = useParams();
  const { setLoading } = useLoader();
  const [complaint, setComplaint] = useState<IComplaint | null>(null);
  const { user } = useUser();

  useEffect(() => {
    if (!user) {
      return;
    }
    Promise.all([fetchComplaints()])
      .then(([complaintData]) => {
        const foundComplaint = complaintData.find(
          (item: IComplaint) => item.id === Number(id),
        );
        setComplaint(foundComplaint || null);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((error) => {
        dynamicFailed(`${error.message}`);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [id, setLoading, user]);
  return (
    <>
      <PageLayout>
        <SearchHeader />
        <div className="inner-main-content">
          <ViewComplaints complaint={complaint} setComplaint={setComplaint}/>
        </div>
      </PageLayout>
    </>
  );
};

export default ViewComplaintsPage;
